import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Loc(props) {
  return (
    <Svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M11 7c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0012 2.06V0h-2v2.06A8.994 8.994 0 002.06 10H0v2h2.06A8.994 8.994 0 0010 19.94V22h2v-2.06A8.994 8.994 0 0019.94 12H22v-2h-2.06zM11 18c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
        fill={props.fill ? props.fill : "#000"}
      />
    </Svg>
  );
}

export default Loc;
